import angular from "angular";
import { UserProfile } from "../../../application/UserProfile";
import {
  PatchModalController,
  PatchModalControllerResult,
} from "./patchModalController";
import {
  CellDoubleClickedEventHandler,
  PatchDoubleClickHandlerConfig,
} from "./models";

export const vsName = "doubleClickHandlerService";

export class DoubleClickHandlerService {
  static $inject = ["$uibModal", "userProfile"];
  constructor(
    private readonly $uibModal: angular.ui.bootstrap.IModalService,
    private readonly userProfile: UserProfile
  ) {}

  patchDoubleClickHandler(
    config: PatchDoubleClickHandlerConfig
  ): CellDoubleClickedEventHandler {
    return (args) => {
      if (
        config.requiresPermission &&
        !this.userProfile.hasPermission(config.requiresPermission)
      ) {
        return;
      }
      this.$uibModal
        .open({
          template: require("!html-loader!./patchModalTemplate.html").default,
          controller: PatchModalController,
          controllerAs: "modalController",
          resolve: {
            patchDoubleClickHandlerConfig: () => config,
            patchDoubleClickHandlerArgs: () => args,
          },
        })
        .result.then((result: PatchModalControllerResult) => {
          if (result.patched) {
            config.fetchRecord(args).then((updatedRecord) => {
              if (updatedRecord === undefined) {
                return;
              }

              //can't figure out how to get ahold of the grid's data array so I can't directly replace the object
              //Instead clean it out and replace with the property's on the new record

              const target = args.data;

              Object.keys(target).forEach((key) => {
                delete target[key];
              });

              Object.keys(updatedRecord).forEach((key) => {
                target[key] = updatedRecord[key];
              });

              args.api.refreshView();
            });
          }
        });
    };
  }
}
